import { render, staticRenderFns } from "./AdminSandpitItemName.vue?vue&type=template&id=d1bfcaec&scoped=true&"
import script from "./AdminSandpitItemName.vue?vue&type=script&lang=ts&"
export * from "./AdminSandpitItemName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bfcaec",
  null
  
)

export default component.exports